module.exports = __webpack_public_path__ + "static/media/0021_IMG_LE_SOL_MEGALITH_MEGABLACK.ba888406.webp";